import { Box, TextField, Typography, Divider, Snackbar, Alert, Grid, Button, InputAdornment } from "@mui/material";
import { useState } from "react";
import "../../../styles/admin.css/machine-modifications-css/add-car.css";
import { useAddCarMutation } from "../../../redux/slices/admin/machine/addCarSlince.js";

export default function AddCar({ sidebarOpen }) {
  const defaultPlate = "00-AA-000";

  const [addCar, { isLoading }] = useAddCarMutation();
  const [toast, setToast] = useState({ open: false, severity: "success", message: "" });
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    model: "",
    plateNumber: defaultPlate,
  });
  const [plateTouched, setPlateTouched] = useState(false);

  const handleCloseToast = () => setToast({ ...toast, open: false });

  const handleChange = (field, value) => {
    switch (field) {
      case "firstName":
      case "lastName":
        setFormData({
          ...formData,
          [field]: value.replace(/[^\p{L}\s]/gu, ""),
        });
        break;
      case "phone":
        const phone = value.replace(/\D/g, "").slice(0, 9);
        setFormData({ ...formData, phone });
        break;
      case "model":
        setFormData({ ...formData, model: value.replace(/[^\p{L}\p{N}\s]/gu, "") });
        break;
      case "plateNumber":
        let raw = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
        let p1 = raw.slice(0, 2).replace(/\D/g, "");
        let p2 = raw.slice(2, 4).replace(/[^A-Z]/g, "");
        let p3 = raw.slice(4, 7).replace(/\D/g, "");
        let formatted = p1;
        if (raw.length > 2) formatted += "-" + p2;
        if (raw.length > 4) formatted += "-" + p3;
        setFormData({ ...formData, plateNumber: formatted });
        break;
      default:
        setFormData({ ...formData, [field]: value });
    }
  };

  const isPlateValid = /^(\d{2}-[A-Z]{2}-\d{3})$/.test(formData.plateNumber);
  const isFormInvalid =
    !formData.firstName.trim() ||
    formData.phone.length !== 9 ||
    !formData.model.trim() ||
    !isPlateValid ||
    formData.plateNumber === defaultPlate;

  const handleSubmit = async () => {
    if (isFormInvalid) return;

    const payload = {
      firstName: formData.firstName.trim(),
      lastName: formData.lastName.trim() || null,
      phone: formData.phone,
      plateNumber: formData.plateNumber,
      model: formData.model.trim(),
    };

    try {

      await addCar(payload).unwrap();
      setToast({ open: true, severity: "success", message: "Əlavə olundu!" });

      setFormData({
        firstName: "",
        lastName: "",
        phone: "",
        plateNumber: defaultPlate,
        model: "",
      });
      setPlateTouched(false);

    } catch (err) {
      setToast({ open: true, severity: "error", message: err?.data?.message || "Xəta baş verdi!" });
    }
  };

  return (
    <Box className="profile-container">
      <Typography className="profile-title">Avtomobil məlumatı</Typography>
      <Divider className="profile-divider" />


      <Grid container spacing={0} sx={{ mb: 2 }}>
        <Grid item xs style={{ flex: 1, paddingRight: 8 }}>
          <TextField
            fullWidth
            label="Ad"
            value={formData.firstName}
            onChange={(e) => handleChange("firstName", e.target.value)}
          />
        </Grid>

        <Grid item xs style={{ flex: 1, paddingLeft: 8 }}>
          <TextField
            fullWidth
            label="Soyad"
            value={formData.lastName}
            onChange={(e) => handleChange("lastName", e.target.value)}
          />
        </Grid>
      </Grid>

      <Grid container spacing={0} sx={{ mb: 2 }}>
        <Grid item xs style={{ flex: 1, paddingRight: 8 }}>
          <TextField
            fullWidth
            label="Əlaqə nömrəsi"
            value={formData.phone}
            onChange={(e) => handleChange("phone", e.target.value)}
            InputProps={{
              startAdornment: <InputAdornment position="start">+994</InputAdornment>,
              inputMode: "numeric",
            }}
            helperText={formData.phone.length > 0 && formData.phone.length < 9 ? "9 rəqəm olmalıdır" : ""}
            error={formData.phone.length > 0 && formData.phone.length < 9}
          />
        </Grid>

        <Grid item xs style={{ flex: 1, paddingLeft: 8 }}>
          <TextField
            fullWidth
            label="Model"
            value={formData.model}
            onChange={(e) => handleChange("model", e.target.value)}
          />
        </Grid>
      </Grid>


      <Grid container spacing={0}>
        <Grid item xs style={{ flex: 1 }}>
          <TextField
            fullWidth
            label="Nömrə nişanı"
            value={plateTouched ? formData.plateNumber : defaultPlate}
            onFocus={() => {
              if (!plateTouched && formData.plateNumber === defaultPlate) {
                setFormData({ ...formData, plateNumber: "" });
              }
              setPlateTouched(true);
            }}
            onBlur={() => {
              if (!formData.plateNumber) {
                setFormData({ ...formData, plateNumber: defaultPlate });
                setPlateTouched(false);
              }
            }}
            onChange={(e) => handleChange("plateNumber", e.target.value)}
            inputProps={{
              inputMode: "text",
              pattern: "[0-9A-Z]*",
              style: {
                color: !plateTouched && formData.plateNumber === defaultPlate ? "#545A61" : "black",
              },
            }}
          />
        </Grid>
      </Grid>

      <Box style={{ marginTop: 24, display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={isFormInvalid || isLoading}>
          Əlavə et
        </Button>
      </Box>

      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: "100%" }}>
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
